<lvr-basic-layout [class.representation-active]="isRepresentationActive()">
	<lvr-basic-layout-header>
		<span class="header-layout-logo-area">
			<span class="header-layout-logo-slot">
				<img [src]="logo()" alt="Logo" class="header-layout-logo" loading="eager" fetchpriority="high" />
				@if (logo() === '/image/lvr_logo_blau_gruen_sRGB.svg') {
					<span class="header-layout-logo-tagline">{{ 'default_layout.logo_tagline' | transloco }}</span>
				}
			</span>
		</span>

		<lvr-global-search></lvr-global-search>

		<span></span>
	</lvr-basic-layout-header>

	<lvr-basic-layout-left>
		<lvr-sidebar>
			<lvr-sidebar-button
				*lvrPermission="'Institutions.Create'"
				icon="domain_add"
				label="Neu: Institution"
				(selected)="openNewInstitutionDialog()"
			></lvr-sidebar-button>
			@if (canCreateClients()) {
				<lvr-sidebar-button
					icon="person_add"
					label="Neu: Klient"
					(selected)="openNewClientDialog()"
				></lvr-sidebar-button>
			}
			<lvr-sidebar-button
				*lvrPermission="'Contacts.Create'"
				icon="connect_without_contact"
				label="Neu: Netzwerkkontakt"
				[route]="['/desk', 'network-contact', 'add']"
			></lvr-sidebar-button>
			<lvr-sidebar-button
				*lvrPermission="'Users.Create'"
				ngProjectAs="temp-entries"
				icon="manage_accounts"
				label="Anwenderverwaltung"
				[route]="['/admin', 'users']"
			></lvr-sidebar-button>
		</lvr-sidebar>
	</lvr-basic-layout-left>
	<router-outlet></router-outlet>
	<lvr-representation-banner></lvr-representation-banner>
	<lvr-button
		class="updates-btn attention"
		variant="primary"
		size="small"
		[label]="'update_page.button_update_page' | transloco"
		[type]="'button'"
		(clicked)="goToWiki()"
		icon="notifications"
	></lvr-button>
</lvr-basic-layout>
